const btnPrimary =
  "px-3 py-1.5 font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed rounded";

const MessageCard = ({
  message,
  onChange,
  onSend,
  placeholder = "Write your message...",
  disabled = false,
}) => {
  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Messages</h2>
      </div>

      <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
        <textarea
          value={message}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          rows={6}
          className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
        />

        <div>
          <button onClick={onSend} disabled={disabled} className={btnPrimary}>
            Send message to client
          </button>
        </div>
      </div>
    </section>
  );
};

export default MessageCard;
